import {useEffect, useState} from 'react';
import {_requests} from '../../configuration/index.config';
import {useSetTimeout} from '../useSetTimeout/useSetTimeout';
import {storageService} from '../../services/storageService';
const {UrlDev} = _requests;
const WS_URL = `${UrlDev.WS}${UrlDev.SIA_API_HOST}`;

export const useWebSocket = (addToTogglesList) => {
    const [ws, setWs] = useState<any>(null);
    const [data, setData] = useState<any>(null);
    const {_setTimeOut} = useSetTimeout();
    const setRoute = () => {
        const urlArray = window.location.href.split('/');

        urlArray[urlArray.length - 1] && setWs(new WebSocket(`${WS_URL}/${storageService.loadFromStorage('token')}/`));
    };

    /**
     * sendData - send data through ws
     * @param data - data to ws
     */
    const sendData = (data) => ws && ws.send(JSON.stringify(data));

    /**
     * initConnection - start ws events
     */
    const initConnection = () => {
        ws.onopen = () => {
            ws.onmessage = (dataFromServer) => {
                const wsData = JSON.parse(dataFromServer.data);

                sendNotification(wsData);
                setData(wsData);
            };
        };
        ws.onClose = () => {
            _setTimeOut(() => {
                setRoute();
            }, 2000);
        };
    };

    /**
     * sendNotification -send Notification
     * @param wsData - websocket data
     */
    const sendNotification = (wsData) => {
        if (wsData) {
            const {type, status, info} = wsData;
            const caseType = (type && status) ? `${type.toLowerCase()}_${status.toLowerCase()}` : 'error';

            switch (caseType) {
                case 'track_error':
                    addToTogglesList('red', `${info.file_name} failed to track`);
                    break;
                case 'track_tracked':
                    addToTogglesList('green', `${info.file_name} has tracked successfully`);
                    break;
                case 'training_success':
                    addToTogglesList('green', `${info.feature_name} has trained successfully`);
                    break;
                case 'training_error':
                    addToTogglesList('red', `${info.feature_name} has failed`);
                    break;
                case 'cancel_tracking_canceled':
                    addToTogglesList('blue', `${info.file_name} tracking has canceled`);
                    break;
                case 'error':
                    console.log('on error ws');
                    break;
                default:
                    break;
            }
        }
    };

    /**
     * listen to ws object
     */
    useEffect(() => {
        ws && initConnection();
    }, [ws]);

    useEffect(() => {
        storageService.loadFromStorage('token') && setRoute();
    }, [storageService.loadFromStorage('token')]);

    /**
     * on mount - start ws
     */
    useEffect(() => () => setWs(null), []);

    return {wsData: data, senWsdData: sendData};
};
